export const EMPLOYEE_INFO_PAGE = {
  GENERAL_INFO: "general_info",
  CONTACT_INFO: "contact_info",
  FAMILY: "family",
  WORK_EXPERIENCE: "work_experience",
  EDUCATION: "education",
};

const accessPermission = "ACCESS_EMPLOYEE|EMPLOYEE_INFO";
const visiblePermission = "ACCESS_DATA_SECURITY|EMPLOYEE";
const updatePermission = "UPDATE_EMPLOYEE|EMPLOYEE_INFO";
const createPermission = "CREATE_EMPLOYEE|EMPLOYEE_INFO";

export const PERMISSIONS_CONFIG = {
  [EMPLOYEE_INFO_PAGE.GENERAL_INFO]: {
    'ACCESS': `${accessPermission}|GENERAL_INFO`,
    'VISIBLE': `${visiblePermission}|GENERAL_INFO`,
    'CREATE': `${createPermission}|GENERAL_INFO`,
    'UPDATE': `${updatePermission}|GENERAL_INFO`,
  },
  [EMPLOYEE_INFO_PAGE.CONTACT_INFO]: {
    'ACCESS': `${accessPermission}|CONTACT_INFO`,
    'VISIBLE': `${visiblePermission}|CONTACT_INFO`,
    'CREATE': `${createPermission}|CONTACT_INFO`,
    'UPDATE': `${updatePermission}|CONTACT_INFO`,
  },
  [EMPLOYEE_INFO_PAGE.FAMILY]: {
    'ACCESS': `${accessPermission}|FAMILY`,
    'VISIBLE': `${visiblePermission}|FAMILY`,
    'CREATE': `${createPermission}|FAMILY`,
    'UPDATE': `${updatePermission}|FAMILY`,
  },
  [EMPLOYEE_INFO_PAGE.WORK_EXPERIENCE]: {
    'ACCESS': `${accessPermission}|WORK_EXPERIENCE`,
    'VISIBLE': `${visiblePermission}|WORK_EXPERIENCE`,
    'CREATE': `${createPermission}|WORK_EXPERIENCE`,
    'UPDATE': `${updatePermission}|WORK_EXPERIENCE`,
  },
  [EMPLOYEE_INFO_PAGE.EDUCATION]: {
    'ACCESS': `${accessPermission}|EDUCATION`,
    'VISIBLE': `${visiblePermission}|EDUCATION`,
    'CREATE': `${createPermission}|EDUCATION`,
    'UPDATE': `${updatePermission}|EDUCATION`,
  },
};

export const EMPLOYEE_INFO_PAGE_LIST = Object.values(EMPLOYEE_INFO_PAGE);
